export const environment = {
  production: true,

  // baseUrl: 'https://qaapi.toonsutra.com/api/v1.0',
  // publicUrl: 'https://qaapi.toonsutra.com/',
  // baseUrlV2: 'https://qaapi.toonsutra.com/api/v2.0',
  // publicUrlV2: 'https://qaapi.toonsutra.com/',
  // baseUrlV3: 'https://qaapi.toonsutra.com/api/v3.0',
  // publicUrlV3: 'https://qaapi.toonsutra.com/',

  // baseUrl: 'https://devapi.toonsutra.com/api/v1.0',
  // publicUrl: 'https://devapi.toonsutra.com/',
  // baseUrlV2: 'https://devapi.toonsutra.com/api/v2.0',
  // publicUrlV2: 'https://devapi.toonsutra.com/',
  // baseUrlV3: 'https://devapi.toonsutra.com/api/v3.0',
  // publicUrlV3: 'https://devapi.toonsutra.com/',

  // baseUrl: 'https://uatapi.toonsutra.com/api/v1.0',
  // publicUrl: 'https://uatapi.toonsutra.com/',
  // baseUrlV2: 'https://uatapi.toonsutra.com/api/v2.0',
  // publicUrlV2: 'https://uatapi.toonsutra.com/',
  // baseUrlV3: 'https://uatapi.toonsutra.com/api/v3.0',
  // publicUrlV3: 'https://uatapi.toonsutra.com/',

  baseUrl: 'https://api.toonsutra.com/api/v1.0',
  publicUrl: 'https://api.toonsutra.com/',
  baseUrlV2: 'https://api.toonsutra.com/api/v2.0',
  publicUrlV2: 'https://api.toonsutra.com/',
  baseUrlV3: 'https://api.toonsutra.com/api/v3.0',
  publicUrlV3: 'https://api.toonsutra.com/',

  // baseUrl: 'http://192.168.0.175:7005/api/v1.0',
  // publicUrl: 'http://192.168.0.175:7005/',
  // baseUrlV2: 'http://192.168.0.175:7005/api/v2.0',
  // publicUrlV2: 'http://192.168.0.175:7005/',
  // baseUrlV3: 'http://192.168.0.175:7005/api/v3.0',
  // publicUrlV3: 'http://192.168.0.175:7005/',
};
